'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CamIcon = require('../CamIcon');

var _CamIcon2 = _interopRequireDefault(_CamIcon);

var _SurfConditions = require('../SurfConditions');

var _SurfConditions2 = _interopRequireDefault(_SurfConditions);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _favoritePropType = require('../PropTypes/favoritePropType');

var _favoritePropType2 = _interopRequireDefault(_favoritePropType);

var _conditionClassModifier = require('../helpers/conditionClassModifier');

var _conditionClassModifier2 = _interopRequireDefault(_conditionClassModifier);

var _getUnitType = require('../helpers/getUnitType');

var _getUnitType2 = _interopRequireDefault(_getUnitType);

var _generateSlug = require('../helpers/generateSlug');

var _generateSlug2 = _interopRequireDefault(_generateSlug);

var _spotPagePath = require('../helpers/spotPagePath');

var _spotPagePath2 = _interopRequireDefault(_spotPagePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var favoriteClasses = function favoriteClasses(large, mobile) {
  var classObject = {};
  classObject['quiver-favorite'] = true;
  classObject['quiver-favorite--large'] = large;
  classObject['quiver-favorite--mobile'] = mobile;
  return (0, _classnames2.default)(classObject);
};

var conditionClasses = function conditionClasses(condition) {
  var classObject = {};
  var conditionClass = condition ? (0, _conditionClassModifier2.default)(condition) : '';
  classObject['quiver-favorite__item-condition'] = true;
  classObject['quiver-favorite__item-condition--' + conditionClass] = !!condition;
  return (0, _classnames2.default)(classObject);
};

var isFlat = function isFlat(settings, waveHeight) {
  var min = waveHeight.min,
      max = waveHeight.max;

  var units = (0, _getUnitType2.default)(settings);
  return !min && !max || units === 'FT' && max < 1 || units === 'M' && max < 0.3;
};

var Favorite = function Favorite(_ref) {
  var favorite = _ref.favorite,
      settings = _ref.settings,
      large = _ref.large,
      mobile = _ref.mobile,
      onClickLink = _ref.onClickLink,
      disableLink = _ref.disableLink;
  var _id = favorite._id,
      name = favorite.name,
      conditions = favorite.conditions,
      waveHeight = favorite.waveHeight;

  var showFlat = isFlat(settings, waveHeight);
  var surfHeights = showFlat === false ? waveHeight.min + '-' + waveHeight.max : 'FLAT';
  var slug = (0, _generateSlug2.default)(name);
  var trackingProps = {
    favoriteName: name
  };
  return _react2.default.createElement(
    'li',
    { className: favoriteClasses(large, mobile), key: name },
    _react2.default.createElement(
      'a',
      {
        href: disableLink ? null : (0, _spotPagePath2.default)(_id, slug),
        onClick: function onClick() {
          return onClickLink({ name: 'Clicked Favorite', properties: trackingProps });
        },
        className: 'quiver-favorite__item'
      },
      !large ? _react2.default.createElement('div', { className: conditionClasses(conditions.value) }) : null,
      _react2.default.createElement(
        'div',
        { className: 'quiver-favorite__item__wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-favorite__item__wrapper__top' },
          _react2.default.createElement(
            'span',
            { className: 'quiver-favorite__item__wrapper__top-name' },
            name
          ),
          large && favorite.cameras && favorite.cameras.length ? _react2.default.createElement(_CamIcon2.default, null) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-favorite__item__wrapper__bottom' },
          large ? _react2.default.createElement(_SurfConditions2.default, { conditions: conditions.value || 'LOLA' }) : null,
          _react2.default.createElement(
            'span',
            { className: 'quiver-favorite__item__wrapper__bottom-height' },
            surfHeights
          ),
          _react2.default.createElement(
            'span',
            { className: 'quiver-favorite__item__wrapper__bottom-units' },
            (0, _getUnitType2.default)(settings, showFlat)
          )
        )
      )
    )
  );
};

Favorite.propTypes = {
  disableLink: _propTypes2.default.bool,
  favorite: _favoritePropType2.default.isRequired,
  settings: _settingsPropType2.default.isRequired,
  large: _propTypes2.default.bool,
  mobile: _propTypes2.default.bool,
  onClickLink: _propTypes2.default.func.isRequired
};

Favorite.defaultProps = {
  disableLink: false,
  large: false,
  mobile: false
};

exports.default = Favorite;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Favorite/Favorite.js
// module id = 575
// module chunks = 11